// extracted by mini-css-extract-plugin
export default {"tx":"_8864497f12","line":"_646ca1a273"};